/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isBlank, isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';
import { InAppPreview } from 'cio/utils/previews';
import { Editor } from 'cio/services/editor';

interface SendTestArgs {
  preview: InAppPreview;
  action: ActionModel;
  editorName: Editor;
  template: TemplateModel;
  isDisabled: boolean;
  recipient: string;
  selectedEvent: string;
  selectedCustomer: string;
  isShowingSendTestModal: boolean;
}

export default class SendTest extends Component<SendTestArgs> {
  get isPreviewInvalid() {
    return this.hasPreviewErrors || (this.hasNoMessageSelected && !this.isVisualEditor);
  }

  get isVisualEditor() {
    return this.args.editorName === Editor.VISUAL;
  }

  get sendTestDisabledErrorMessage() {
    let requiredAction = 'Fix errors';
    if (this.hasNoMessageSelected && !this.isVisualEditor) {
      requiredAction = 'Select a message';
    }
    return `${requiredAction} to send a test`;
  }

  get hasNoMessageSelected() {
    let { preview } = this.args;
    return isBlank(preview?.body_json?.messageId);
  }

  get hasPreviewErrors() {
    let { preview } = this.args;
    return !isEmpty(preview?.errors.body_json);
  }
}
